import SupplyChain, { SupplyChainProps } from './SupplyChain'

export default SupplyChain

export { SupplyChainProps, SupplyChain }
